if (!customElements.get('localization-picker')) {
  customElements.define(
    'localization-picker',
    class LocalizationPicker extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-picker-toggle]');
        this.list = this.querySelector('[data-picker-list]');
        this.label = this.querySelector('[data-picker-label]');
        this.flag = this.querySelector('[data-picker-flag]');
        this.form = this.closest('form');

        if (!this.toggle || !this.list) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.toggle.addEventListener('click', this.#onToggleClick.bind(this), { signal });
        this.list.addEventListener('click', this.#onOptionClick.bind(this), { signal });
        document.addEventListener('click', this.#onDocumentClick.bind(this), { signal });
        document.addEventListener('keyup', this.#onKeyUp.bind(this), { capture: true, signal });

        this.closest('basic-modal')?.addEventListener(
          'modal:handleAfterHide',
          this.close.bind(this),
          { signal }
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      get open() {
        return this.hasAttribute('open');
      }

      close() {
        if (!this.open) return;

        this.removeAttribute('open');
        this.toggle?.setAttribute('aria-expanded', 'false');
        this.list?.setAttribute('hidden', '');
      }

      #open() {
        this.#closeOthers();
        this.setAttribute('open', '');
        this.toggle.setAttribute('aria-expanded', 'true');
        this.list.removeAttribute('hidden');
      }

      #onToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.open) {
          this.close();
          return;
        }

        this.#open();
      }

      #onOptionClick(event) {
        const option = event.target.closest('[data-picker-option]');
        if (!option) return;

        event.preventDefault();
        this.#select(option);
        this.close();
        this.toggle?.focus();
      }

      #onDocumentClick(event) {
        if (!this.open) return;
        if (this.contains(event.target)) return;
        this.close();
      }

      #onKeyUp(event) {
        if (event.code !== 'Escape') return;
        if (!this.open) return;

        event.stopImmediatePropagation();
        this.close();
        this.toggle?.focus();
      }

      #closeOthers() {
        if (!this.form) return;

        for (const picker of this.form.querySelectorAll('localization-picker')) {
          if (picker !== this) picker.close();
        }
      }

      #select(option) {
        const value = option.dataset.value;
        if (!value) return;

        const inputName = this.dataset.inputName;
        if (!inputName) return;

        const input = this.form?.querySelector(`input[name="${inputName}"]`);
        if (input) input.value = value;

        const optionLabel = option.querySelector('[data-option-label]');
        if (this.label && optionLabel) {
          this.label.textContent = optionLabel.textContent.trim();
        }

        const optionFlag = option.querySelector('[data-option-flag]');
        if (this.flag && optionFlag) {
          this.flag.style.setProperty(
            '--background-image',
            optionFlag.style.getPropertyValue('--background-image')
          );
          this.flag.className = optionFlag.className;
          this.flag.setAttribute('data-picker-flag', '');
        }

        for (const item of this.querySelectorAll('[data-picker-option]')) {
          const isCurrent = item === option;
          item.classList.toggle('localization-picker__option--current', isCurrent);
          if (isCurrent) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        }
      }
    }
  );
}
